import { ink as viemInk } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const ink = {
  displayName: 'Ink Chain',
  runtime: 'evm',
  viemChain: viemInk,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 13,
  decoration: {
    color: '#7132F5',
    contrastColor: getContrastColor('#7132F5'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'ink-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://explorer.inkonchain.com',
        token: 'https://explorer.inkonchain.com/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    lifi: { chainKey: 'INK' },
    stargate: { chainKey: 'ink' },
    across: { chainKey: 'ink' },
  }),
  services: defaultServices({
    codex: {
      networkId: 57073,
      nativeLiquidityAddress: '0x4200000000000000000000000000000000000006',
    },
    coingecko: {
      networkId: 'ink',
      platformId: 'ink',
    },
    coingeckoDex: {
      networkId: 'ink',
    },
    // trm: { chainKey: 'ink' },
    zerion: { chainKey: 'ink' },
    qnStreams: {
      networkKey: 'ink-mainnet',
    },
    safe: { shortName: 'ink' },
    alchemy: { chainSlug: 'ink-mainnet' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
